import { HttpService } from "@root/services/http";
import { LocalStorageService } from "@root/services/local-storage";
import axios from "axios";
const localStorageService = new LocalStorageService();
export class AdminFileManagement extends HttpService {
  // Get all folders
  fetchFolders = async (baseAuthUrl: string, payload: any): Promise<any> => {
    const url = `${baseAuthUrl}/api/admin/folders`;
    try {
      const apiResponse = await this.get(url, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  // Create new folder
  createFolder = async (baseAuthUrl: string, payload: any): Promise<any> => {
    const url = `${baseAuthUrl}/api/admin/folders`;
    try {
      const apiResponse = await this.post(url, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  //fetch files by folder id
  fetchFiles = async (baseAuthUrl: string, payload: any): Promise<any> => {
    const url = `${baseAuthUrl}/api/admin/documents`;
    try {
      const apiResponse = await this.get(url, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  //Delete file by file id
  DeleteFile = async (baseAuthUrl: string, payload: any): Promise<any> => {
    const url = `${baseAuthUrl}/api/admin/documents/${payload.id}`;
    try {
      const apiResponse = await this.delete(url);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  //fetch files by file id
  DeleteFolder = async (baseAuthUrl: string, payload: any): Promise<any> => {
    const url = `${baseAuthUrl}/api/admin/folders/${payload.id}`;
    try {
      const apiResponse = await this.delete(url);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  fetchProjects = async (baseAuthUrl: string, payload: any): Promise<any> => {
    const url = `${baseAuthUrl}/api/projects`;
    try {
      const apiResponse = await this.get(url, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  //fetch files by folder id
  uploadFile = async (baseAuthUrl: string, payload: any): Promise<any> => {
    const url = `${baseAuthUrl}/api/admin/documents`;
    try {
      const token = await localStorageService.fetch("authToken");
      const apiResponse = await axios.post(url, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return apiResponse.data;
    } catch (error) {
      throw error;
    }
  };

  // Retry failed document processing
  retryDocument = async (baseAuthUrl: string, payload: any): Promise<any> => {
    const url = `${baseAuthUrl}/api/documents/retry-doc`;
    try {
      const apiResponse = await this.post(url, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
